export default __webpack_public_path__ + "static/flight-1-73035aa137832f7ba45b4fc134c3adec.jpg";